import { styled } from '@mui/system';
import { IconButton, Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 14,
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  border: '1px stroke #EAEAEA',
  boxShadow: '0px 0px 5px 0px #D9D9D9',
  borderRadius: '66px',
  maxHeight: '30px',
  maxWidth: 'fit-content',
});

const CartProductCartActionsIconButton = styled(IconButton)(
  ({ width, height }: { width?: number; height?: number }) => ({
    padding: 5,
    margin: 0,
    color: 'rgb(16	100	177)',
    width: width || 30,
    height: height || 30,
  }),
);

const CartProductCartActionsTypography = styled(Typography)({
  fontSize: 18,
  color: '#414046',
  margin: 0,
  maxWidth: 22,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const variantStyles = {
  productView: {
    main: {
      gap: 20,
      height: 40,
      maxHeight: 40,
      maxWidth: 136,
      marginTop: 12,
    },
    iconButton: {
      width: 40,
      height: 40,
    },
  },
};

export type ProductQuantityActionsVariant =
  | keyof typeof variantStyles
  | 'default';

export {
  RootDiv,
  CartProductCartActionsIconButton,
  CartProductCartActionsTypography,
};
